const drawerDim={
    width:250,
    height:70,
    bottom:40
}

export default drawerDim;